import englishMessages from "ra-language-english";

export default {
  ...englishMessages,
  "": "",
  app: {
    bulk_import: {
      title: "Bulk import into campaign with id: %{campaignId}",
      subtitle: "Import a CSV file containing coupons into this campaign. Please use csv-structure that is given in our example (including header).",
      example: "Example CSV structure:",
      button: "Upload a CSV File",
      ok: "Ok",
      messages: {
        invalid_campaign_id: "Please provide a corret campaign ID!",
        wrong_coupon_code: "Wrong coupon code",
        success_import: "Imported.",
        wrong_header_title: "Error parsing CSV file",
        wrong_header: "Incorrect Header in CSV-file. Please use naming convention as shown in example: Expected \"%{expected}\" but \"%{given}\" was given.",
        done_processing: "Done processing CSV file",
        done_processing_description: "Coupons app finished processing the CSV file: please see the results for any errors."
      },
      no_file_loaded: "Waiting for CSV file to process..."
    }
  },
  resources: {
    campaigns: {
      name: "Campaign |||| Campaigns",
      updated: "Campaign \"%{title}\" updated",
      undefaulted: "Removed default from campaign \"%{title}\"!"
    },
    coupons: {
      name: "Coupon |||| Coupons",
      left: "Amount of coupons expired: %{totalExpiredItems}/%{totalItems}"
    }
  }
};
